import React from 'react';
import { Link } from '../../../../@nitty';
import { Container } from '../../../styles';
import styled from 'styled-components';

const NormalLink = styled(Link)`
    padding: 1rem;
    display: inline-block;
    text-decoration: none;
`

const SelectedLink = styled(NormalLink)`
    font-weight: 600;
    position: relative;
    &::after {
        background-color: var(--nitty-backgroundBrandStatic);
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
    }
`

const Wrapper = styled.div`
    border-bottom: 0.0625rem solid var(--nitty-borderSecondary);
    margin-bottom: 1.5rem;
    flex: 1;
`

const View = ({ sections, currentSection }) => {
    return (
        <Container>
            <Wrapper>
                {sections.map((section, index) => {
                    if (currentSection === section.text.toLowerCase())
                        return <SelectedLink key={index} variant="secondary" href={section.href}>{section.text}</SelectedLink>
                    else
                        return <NormalLink key={index} variant="secondary" href={section.href}>{section.text}</NormalLink>
                })}
            </Wrapper>
        </Container>
    );
};

export default View;
